module.exports = {
      id: "apple-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#apple",
      toString: function () {
        return this.url;
      }
    }